import { APIGet, APIPut, APIUrl, AdminType } from "api/protocols";
import { TFacilityMembership } from "api/rpc/2024-04/facilityAdmin/membership/membership";
import { ICustomer } from "redux/reducers/models/customer";

export type TOrderMembershipSlot = {
  id: number;
  order_id: number;
  order_line_item_id: number;
  membership_id: number;
  source: "included" | "modifier";
  customer_id: number | null;
  first_name: string | null;
  last_name: string | null;
  email: string | null;
  send_email: boolean;
  customer_membership_id: number | null;
  sort_order: number;
  membership?: TFacilityMembership;
  customer?: ICustomer;
};

export async function GetOrderMembershipSlots(params: { order_id: number }, useGlobalLoader: boolean) {
  return await APIGet<TOrderMembershipSlot[]>(
    APIUrl(AdminType.FacilityAdmin, "/order/membership-slots"),
    params,
    useGlobalLoader,
  );
}

export async function PutOrderMembershipSlots(
  params: {
    order_id: number;
    slots: Array<{
      id: number;
      customer_id?: number;
      first_name?: string;
      last_name?: string;
      email?: string;
      send_email?: boolean;
    }>;
  },
  useGlobalLoader: boolean,
) {
  return await APIPut<TOrderMembershipSlot[]>(
    APIUrl(AdminType.FacilityAdmin, "/order/membership-slots"),
    params,
    useGlobalLoader,
  );
}
